export default "__VITE_ASSET__BzSEZ0mJ__"